import produce from 'immer';

import {
  FETCH_WATCH_HISTORY_REQUESTING,
  FETCH_WATCH_HISTORY_ABORTED,
  FETCH_WATCH_HISTORY_FAILED,
  FETCH_WATCH_HISTORY_SUCCEEDED,
  LOGOUT,
} from '../../constants/actionTypes';

import {
  REQUEST_STATE_READY,
  REQUEST_STATE_REQUESTING,
  REQUEST_STATE_ABORTED,
  REQUEST_STATE_FAILED,
  REQUEST_STATE_SUCCEEDED,
} from '../../../constants/state';

const initState = REQUEST_STATE_READY;

export default produce((draft, action) => {
  switch (action.type) {
    case FETCH_WATCH_HISTORY_REQUESTING: {
      return REQUEST_STATE_REQUESTING;
    }

    case FETCH_WATCH_HISTORY_ABORTED: {
      return REQUEST_STATE_ABORTED;
    }

    case FETCH_WATCH_HISTORY_FAILED: {
      return REQUEST_STATE_FAILED;
    }

    case FETCH_WATCH_HISTORY_SUCCEEDED: {
      return REQUEST_STATE_SUCCEEDED;
    }

    case LOGOUT: {
      return initState;
    }
  }
}, initState);
